import {ConstantsParser} from "../../../ConstantsParser";
import {StylesParser} from "../../../StylesParser";

export class Secondary {
  constructor() {
    this.name = 'Secondary'
    this.content = {
      hasIcon: false,
      hasDescription: false,
      class: 'fas',
      icon: 'fa-list-ol',
      items: [
        {
          'title': 'Item List #1',
          'description': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry...',
        }, {
          'title': 'Item List #2',
          'description': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry...',
        }, {
          'title': 'Item List #3',
          'description': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry...',
        }
      ]
    }
    this.view = this.viewHtml()
  }

  viewHtml() {
    return `
      <i
        class="fas fa-list-ol ${this.classes()}"
      />
    `
  }

  classes() {
    return (new ConstantsParser(this.classesProperties())).parse().join(' ')
  }

  classesProperties() {
    return [
      {property: 'FontSize', value: 'FONT_SIZE_BASE'},
      {property: 'ListsStyle', value: 'STYLE_DECIMAL'},
    ]
  }

  styles() {
    let styles = (new StylesParser(this.stylesProperties())).parse();
    return Object.keys(styles).map(variationStyle => `${variationStyle}:${styles[variationStyle]}`).join(';')
  }

  stylesProperties() {
    return []
  }

  listsClassesProperties() {
    return []
  }

  containerClassesProperties() {
    return [];
  }

  iconContainerClassesProperties() {
    return [
      {property: 'Rounded', value: 'ROUNDED_FULL'},
      {property: 'Size', value: 'SIZE_MD'},
    ]
  }
  iconContainerStylesProperties() {
    return [
      {property:'BackgroundColor', styleProperty: 'background-image', value: 'linear-gradient(0deg, #4c51bf, #4c51bf)'},
    ]
  }
  iconStylesProperties() {
    return [
      {property:'IconSize', value: 'ICON_SIZE_SM'},
      {property:'TextColor', styleProperty: 'color', value: '#ffffff'},
    ]
  }

  descContainerClassesProperties() {
    return [
      {property: 'FontWeight', value: 'HAIRLINE'},
      {property: 'FontSize', value: 'FONT_SIZE_XS'},
    ]
  }

  descContainerStylesProperties() {
    return []
  }

  descStylesProperties() {
    return [
      {property:'TextColor', styleProperty: 'color', value: '#cccccc'},
    ]
  }

  buildData() {
    return {
      name: this.name,
      view: this.view,
    }
  }

  editorProperties() {
    return {
      content: this.content,
      classes: {
        desktop: this.classesProperties(),
        tablet: this.classesProperties(),
        phone: this.classesProperties(),
      },
      containerClasses: {
        desktop: this.containerClassesProperties(),
        tablet: this.containerClassesProperties(),
        phone: this.containerClassesProperties(),
      },
      styles: {
        desktop: this.stylesProperties(),
        tablet: this.stylesProperties(),
        phone: this.stylesProperties()
      },
      listsClasses: {
        desktop: this.listsClassesProperties(),
        tablet: this.listsClassesProperties(),
        phone: this.listsClassesProperties()
      },
      iconContainerClasses: {
       desktop: this.iconContainerClassesProperties(),
       tablet: this.iconContainerClassesProperties(),
       phone: this.iconContainerClassesProperties()
      },
      iconContainerStyles: {
        desktop: this.iconContainerStylesProperties(),
        tablet: this.iconContainerStylesProperties(),
        phone: this.iconContainerStylesProperties()
      },
      iconStyles: {
        desktop: this.iconStylesProperties(),
        tablet: this.iconStylesProperties(),
        phone: this.iconStylesProperties()
      },
      descContainerClasses: {
        desktop: this.descContainerClassesProperties(),
        tablet: this.descContainerClassesProperties(),
        phone: this.descContainerClassesProperties()
      },
      descContainerStyles: {
        desktop: this.descContainerStylesProperties(),
        tablet: this.descContainerStylesProperties(),
        phone: this.descContainerStylesProperties(),
      },
      descStyles: {
        desktop: this.descStylesProperties(),
        tablet: this.descStylesProperties(),
        phone: this.descStylesProperties()
      }
    }
  }
}
